module.exports = __webpack_public_path__ + "static/cc-3-0cdbd78e15bb7cfca303d85b7b53eb88.jpg";